import { Dialog, DialogContent, DialogTitle } from '../ui/custom/Dialog';

import { useTheme } from '../../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: React.ReactNode;
  confirmText: string;
  confirmButtonClass?: string;
  icon?: React.ReactNode;
  isLoading?: boolean;
}

export default function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  confirmButtonClass = 'bg-blue-600 hover:bg-blue-700',
  icon,
  isLoading = false
}: ConfirmationModalProps) {
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogTitle className="flex items-center gap-2">
          {icon}
          {title}
        </DialogTitle>
        <div className="py-3">
          <p className={theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}>{message}</p>
        </div>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isLoading}
            className={`px-4 py-2 text-sm font-medium rounded-md ${
              theme === 'dark'
                ? 'text-gray-300 bg-gray-700 hover:bg-gray-600 disabled:opacity-50'
                : 'text-gray-700 bg-gray-100 hover:bg-gray-200 disabled:opacity-50'
            }`}
          >
            {t('common.cancel')}
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={`px-4 py-2 text-sm font-medium text-white rounded-md disabled:opacity-50 ${confirmButtonClass}`}
          >
            {isLoading ? t('common.processing') : confirmText}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
